import style from "../../../assets/scss/sub/downloadTest.module.scss";
import warning from "../../../assets/images/icons/warning_icon.png"

interface Args {
    title: string;
    desc: string;
}

export function GuideWarningArea(
    {title, desc}: Args
) {
    return (
        <li className={style.warningArea}>
            <div className={style.textArea}>
                <div className={style.warningImage}>
                    <img src={warning} alt={warning}/>
                </div>
                <div className={style.descText}>
                    <span className={style.text}>{title}</span>
                    <span className={style.warningText}>{desc}</span>
                </div>
            </div>
        </li>
    )
}